import { useFormikContext } from 'formik';
import { GipReportValues } from '../../types';
import { LoadOrderParamsBtn } from './LoadOrderParamsBtn';

export function LoadOrderParamsFromOrdersField() {
  const { values } = useFormikContext<GipReportValues>();

  if (!values.orders.length) {
    return null;
  }

  return <LoadOrderParamsBtn ordersIds={values.orders} />;
}
